var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.app_env == "local" || _vm.app_env == "development"
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.name == "services",
              expression: "$route.name == 'services'",
            },
          ],
          attrs: { id: "toggle-services-view" },
        },
        [
          _c(
            "span",
            {
              staticClass: "map-view toggle-button",
              class: { active: _vm.servicesView == "map" },
              on: {
                click: function ($event) {
                  return _vm.displayView("map")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("general.mapView")))]
          ),
          _c(
            "span",
            {
              staticClass: "list-view toggle-button",
              class: { active: _vm.servicesView == "list" },
              on: {
                click: function ($event) {
                  return _vm.displayView("list")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("general.listView")))]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }